/**
 * stripAddToOfferId — search-param reducer shared by `/map` and `/media-units`
 * to exit offer-context mode: removes `addToOfferId` from the URL while
 * preserving every other search param.
 *
 * Each route still creates its own route-typed `navigate` (via
 * `useNavigate({ from: Route.fullPath })`) and passes this reducer directly
 * as `search`, so TanStack Router infers `T` from that route's own search
 * schema — no cast needed, and the reducer body isn't duplicated per route.
 */
export function stripAddToOfferId<T extends { addToOfferId?: unknown }>(
  prev: T,
): Omit<T, 'addToOfferId'> {
  const rest = { ...prev };
  delete rest.addToOfferId;
  return rest;
}
